'use client';

import IMAGE_CONSTANTS from '@/constants/image.constants';
import { useTheme } from 'next-themes';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { cn } from '@/utils/common.utils';

export default function CpIconLogo({ className }: { className?: string }) {
	const [cplogoSrc, setCplogoSrc] = useState(IMAGE_CONSTANTS.CPLOGO_ICON_PRIMARY);
	const { resolvedTheme } = useTheme();

	useEffect(() => {
		setCplogoSrc(
			resolvedTheme === 'dark' ? IMAGE_CONSTANTS.CPLOGO_ICON_WHITE : IMAGE_CONSTANTS.CPLOGO_ICON_PRIMARY,
		);
	}, [resolvedTheme]);

	return (
		<div className={cn('relative mx-auto h-16 w-16', className)}>
			{cplogoSrc && <Image src={cplogoSrc} alt="ClassPoint logo" fill />}
		</div>
	);
}
